import { render, staticRenderFns } from "./floating-upload-panel.vue?vue&type=template&id=5010f1bd&scoped=true"
import script from "./floating-upload-panel.vue?vue&type=script&lang=js"
export * from "./floating-upload-panel.vue?vue&type=script&lang=js"
import style0 from "./floating-upload-panel.vue?vue&type=style&index=0&id=5010f1bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5010f1bd",
  null
  
)

export default component.exports